import * as types from './constants'

const initialState = {
  enableWelcomeEmail: -1,
  disableEmailNewCourse: -1,
  enableModuleLibrary: -1,
  enableModuleMyReport: -1,
  enableModuleDiscussion: -1,
  enableCourseRedirectUrl: -1,
  enableModuleLearningPlan: -1,
  enableModuleCompliance: -1,
  enableModuleDevelopment: -1,
  enableModuleForms: -1,
  enableModuleRecruitment: -1,
  enablePublicCatalog: -1,
  userAdminMarkQuizPassed: -1,
  enableModuleManagerReport: -1,
  notStarted: '#E0E0D5',
  inProgress: '#000000',
  quizFailed: '#ff0000',
  validation: '#0000ff',
  completed: '#4caf50',
  expired: '#ff6347',
  reassigned: '#ff6347',
  pastDue: '#e2515a',
  userAdminMarkCourseComplete: -1,
  userCourseManagerCanAddUser: -1,
  userCourseManagerCanEditUser: -1,
  enableCourseQuizRetakeDefault: -1,
  userAreaAdminCanCreateCourses: -1,
  userAreaAdminCanCreateCourseGroups: -1,
  enableCourseGeneratingCertificate: -1,
  enableCourseShowPastDueTrainings: -1,
  userCourseManagerCanCreateCourse: -1,
  enableGroupsManagerReport: -1,
  enableCoursesManagerReport: -1,
  includeDefaultCourses: -1,
  enableCertificateBlinking: -1,
  requireAgreementBeforeCertification: -1,
  enableEmailCertificate: -1,
  enableCategories: -1,
  enableCourseGroupChecklist: -1,
  enableUserExtraFields: -1,
  enableUserAppearanceWithSameAccessLevel: -1,
  enableModuleAllCourses: -1,
  sortCoursesByOrder: -1,
  enableStatusLabels: 1,
  enableKnowledgeQuestions: 1,
  enableChecklistPercentage: 1,
  enableReorderCourseGroup: -1,
  enableExternalReports: -1,
  enableRoleGroups: -1,
  enableLibraryUpdateEmail: -1,
  //   subject: 'Complete Your Journey Through [courses] Certificate Awaits!',
  //   emailBody: `
  //     <h2 style="color:black;">You're Almost There!</h2>
  //     <p style="font-size:14px;color:black;">
  //         Your journey through [courses] is nearing completion, and we encourage you to take the final step to finish the course and claim your certificate of completion.
  //     </p>
  //     <p style="font-size:14px;color:black;">
  //         This course is designed to equip you with essential knowledge about one of the most significant places in Islamic history.
  //     </p>
  //     <p style="font-size:14px;color:black;">
  //         📜 Don’t miss out—finish your course today!
  //     </p>
  //     <p style="font-size:14px;color:black;">
  //         If you have any questions or need support, feel free to reach out to
  //         <a href="mailto:info@gocise.org" style="color:#007bff;text-decoration:none;">info@gocise.org</a>.
  //         We look forward to celebrating your achievement!
  //     </p>
  //     <p style="font-size:14px;color:black;">Jazakum Allah khayr,</p>
  //     <p style="font-size:14px;color:black;">CISE Team</p>
  // `,
  subject: '',
  emailBody: '',
  agreementContent: '',
}

const courseConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_COURSE_SETTINGS:
      return {
        ...state,
        enableWelcomeEmail: parseInt(action.data.enable_welcome_email),
        disableEmailNewCourse: parseInt(action.data.disable_email_new_course),
        enableModuleLibrary: parseInt(action.data.enable_module_library),
        enableModuleMyReport: parseInt(action.data.enable_module_my_report),
        enableModuleDiscussion: parseInt(action.data.enable_module_discussion),
        enableCourseRedirectUrl: parseInt(
          action.data.enable_course_redirect_url
        ),
        enableModuleLearningPlan: parseInt(
          action.data.enable_module_learning_plan
        ),
        enableModuleDevelopment: parseInt(
          action.data.enable_module_development
        ),
        enableModuleForms: parseInt(action.data.enable_module_forms),
        enableRecruitment: parseInt(action.data.enable_module_recruitment),
        enableModulePublicCatalog: parseInt(
          action.data.enable_module_public_catalog
        ),
        enableModuleCompliance: parseInt(action.data.enable_module_compliance),
        userAdminMarkQuizPassed: parseInt(
          action.data.user_admin_mark_quiz_passed
        ),
        enableModuleManagerReport: action.data.enable_module_manager_report,
        notStarted: action.data.module_course_status_color_0,
        inProgress: action.data.module_course_status_color_1,
        quizFailed: action.data.module_course_status_color_2,
        validation: action.data.module_course_status_color_3,
        completed: action.data.module_course_status_color_4,
        expired: action.data.module_course_status_color_expired,
        reassigned: action.data.module_course_status_color_reassign,
        pastDue: action.data.module_course_status_color_past_due,
        userAdminMarkCourseComplete: parseInt(
          action.data.user_admin_mark_course_complete
        ),
        userCourseManagerCanAddUser: parseInt(
          action.data.user_course_manager_can_add_user
        ),
        userCourseManagerCanEditUser: parseInt(
          action.data.user_course_manager_can_edit_user
        ),
        enableCourseQuizRetakeDefault: parseInt(
          action.data.enable_course_quiz_retake_default
        ),
        userAreaAdminCanCreateCourses: parseInt(
          action.data.user_area_admin_can_create_courses
        ),
        userAreaAdminCanCreateCourseGroups: parseInt(
          action.data.user_area_admin_can_create_course_groups
        ),
        enableCourseGeneratingCertificate: parseInt(
          action.data.enable_course_generating_certificate
        ),
        enableCourseShowPastDueTrainings: parseInt(
          action.data.enable_course_show_past_due_trainings
        ),
        userCourseManagerCanCreateCourse: parseInt(
          action.data.user_course_manager_can_create_course
        ),
        enableGroupsManagerReport: parseInt(
          action.data.enable_groups_manager_report
        ),
        enableCoursesManagerReport: parseInt(
          action.data.enable_courses_manager_report
        ),
        includeDefaultCourses: parseInt(action.data.include_default_courses),
        enableCertificateBlinking: parseInt(
          action.data.enable_certificate_blinking
        ),
        requireAgreementBeforeCertification: parseInt(
          action.data.require_agreement_before_certification
        ),
        subject: action.data.subject,
        emailBody: action.data.emailBody,
        agreementContent: action.data.agreementContent,
        enableEmailCertificate: parseInt(action.data.enable_email_certificate),
        enableCategories: parseInt(action.data.enable_categories),
        enableCourseGroupChecklist: parseInt(
          action.data.enable_course_group_checklist
        ),
        enableUserExtraFields: parseInt(action.data.enable_user_extra_fields),
        enableUserAppearanceWithSameAccessLevel: parseInt(
          action.data.enable_user_appearance_with_same_access_level
        ),
        sortCoursesByOrder: parseInt(action.data.sort_courses_by_order),
        enableStatusLabels: parseInt(action.data.enable_status_labels),
        enableKnowledgeQuestions: parseInt(
          action.data.enable_knowledge_questions
        ),
        enableChecklistPercentage: parseInt(
          action.data.enable_checklist_percentage
        ),
        enableModuleAllCourses: parseInt(action.data.enable_module_all_courses),
        // recently added
        enableReorderCourseGroup: parseInt(
          action.data.enable_reorder_course_groups
        ),
        enableExternalReports: parseInt(action.data.enable_external_reports),
        enableRoleGroups: parseInt(action.data.enable_role_groups),
        enableLibraryUpdateEmail: parseInt(
          action.data.enable_library_update_email
        ),
      }
    case types.SET_COURSE_SETTINGS_VALUE:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.SET_STATUS_COLOR:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.SET_SUBJECT:
      return {
        ...state,
        subject: action.payload,
      }
    case types.SET_EMAIL:
      return {
        ...state,
        emailBody: action.payload,
      }
    case types.SET_AGREEMENT_CONTENT:
      return {
        ...state,
        agreementContent: action.payload,
      }
    default:
      return state
  }
}

export default courseConfigReducer
